import { IDragon } from "../interfaces/dragon"

//
export function getHighestRankDragon(dragons: IDragon[]) {
    let bestDragon = null;

    if (dragons && dragons.length > 0) {
        let maxTotalRank = dragons[0].score.total;
        bestDragon = dragons[0];

        for (let i = 0; i < dragons.length; i++) {
            let d = dragons[i];

            if (d.score.total > maxTotalRank) {
                maxTotalRank = d.score.total;
                bestDragon = d;
            }
        }
    }

    return bestDragon;
}

//
export function getDragonMetatagDescription(dragon: IDragon) {
    // Dont show all dragon metadata!
    let wlAttrs = ['Class', 'Affinity', 'Rarity', 'Spine', 'Horns', 'Neck', 'Face', 'Tusk', 'Eye', 'DNA'];
    let description = "";

    for (let i = 0; i < dragon.attributes.length; i++) {
        let attr = dragon.attributes[i];

        if (wlAttrs.find((wlattr: any) => wlattr === attr.trait_type)) {
            if (description !== '') {
                description += ", ";
            }

            description += `${attr.trait_type}: ${attr.value}`;
        }
    }

    return description;
}

export const DRAGON_TRAITS_PERCENTAGES:any = {
    "Class": {
        "Guardian": "11.11%",
        "Fighter": "11.12%",
        "Mage": "11.11%",
        "Hunter": "11.11%",
        "Slayer": "11.11%",
        "Tanker": "11.11%",
        "Assassin": "11.11%",
        "Warlock": "11.11%",
        "Druid": "11.11%"
    },
    "Affinity": {
        "Earth": "9.00%",
        "Wind": "9.00%",
        "Metal": "9.00%",
        "Nature": "9.00%",
        "Psychic": "9.00%",
        "Void": "9.00%",
        "Water": "9.00%",
        "Fire": "9.00%",
        "Ice": "9.00%",
        "Energy": "9.00%",
        "Light": "5.00%",
        "Dark": "5.00%"
    },
    "Spine": {
        "Powerful": "30.07%",
        "Barbed": "5.22%",
        "Rugged": "15.13%",
        "Malefic": "10.04%",
        "None": "39.54%"
    },
    "Horns": {
        "Elder": "1.08%",
        "Robust": "5.71%",
        "Fiery": "5.95%",
        "Courageous": "0.97%",
        "Distinguished": "0.97%",
        "Durable": "1.04%",
        "Agile": "20.62%",
        "Regal": "1.14%",
        "Mercurial": "15.98%",
        "Bovine": "17.80%",
        "Wild": "0.85%",
        "Slim": "5.97%",
        "Violent": "5.72%",
        "Spiked": "16.20%"
    },
    "Neck": {
        "Nimble": "30.31%",
        "Powerful": "50.07%",
        "Thorny": "4.86%",
        "Impeccable": "14.76%"
    },
    "Face": {
        "Brooding": "15.56%",
        "Playful": "30.11%",
        "Vehement": "34.31%",
        "Distinguished": "20.02%",
    },
    "Tusk": {
        "Enchanting": "45.51%",
        "Scarred": "15.28%",
        "Foreboding": "4.92%",
        "Worn": "34.29%"
    },
    "Eye": {
        "Sharp": "27.63%",
        "Piercing": "19.62%",
        "All-seeing": "10.16%",
        "Brutal": "22.61%",
        "Ferocious": "14.61%",
        "Wise": "5.37%"
    }
}
